import { validateAddress as taquitoValidateAddress } from '@taquito/utils';

export const removeDuplicates = (a: string[]) => {
  const trim = Array.from(new Set(a), (x) => {
    return x.replace(/\s+/g, ' ').trim();
  });

  return trim
    .reduce((unique: string[], item: string) => {
      return unique.includes(item) ? unique : [...unique, item];
    }, [])
    .filter((e) => e !== '');
};

// removes duplicates
export const sanitiseTags = (tags: string) => {
  // substitute # for ,
  // removes space before and after ,
  // splitc by comma or hash
  return removeDuplicates(
    tags
      .replace(/#/g, ',')
      .replace(/\s*,\s*/g, ',')
      .split(/[#,]+/)
  );
};

// validates tezos address
export const validateAddress = (address: string) => {
  return taquitoValidateAddress(address);
};

// validates tezos domain
export const validateDomain = (domain: string) => {
  // const regexp = new RegExp(/^[a-z]{2,51}\.tez$/);
  // reference https://gitlab.com/tezos-domains/client/-/blob/master/packages/core/src/validator/validators.ts
  const regexp = /^[a-z0-9-]{1,100}\.tez$/;
  return regexp.test(domain);
};
